const SYNODIC_MONTH_DAYS = 29.530588;

export function normalizeMoonAge(ageDays: number): number {
  if (!Number.isFinite(ageDays)) return 0;
  return ((ageDays % SYNODIC_MONTH_DAYS) + SYNODIC_MONTH_DAYS) % SYNODIC_MONTH_DAYS;
}

export function roundMoonAgeForImage(ageDays: number): number {
  const normalized = normalizeMoonAge(ageDays);
  return Math.min(29.5, Math.round(normalized * 2) / 2);
}

export function localMoonImagePath(ageDays: number): string {
  const roundedAge = roundMoonAgeForImage(ageDays);
  return `/assets/moon/moon-${roundedAge.toFixed(1)}.jpg`;
}
